import { render } from "./Pin.vue?vue&type=template&id=40fe846f&scoped=true&ts=true"
import script from "./Pin.vue?vue&type=script&lang=ts"
export * from "./Pin.vue?vue&type=script&lang=ts"

import "./Pin.vue?vue&type=style&index=0&id=40fe846f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EugenePrice\\repos\\thinkspatial\\expenses-ionic-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40fe846f"]])

export default __exports__